// extracted by mini-css-extract-plugin
export default {"contactFormSection":"getSolar_contactFormSection__RSF+-","headerSection":"getSolar_headerSection__kXucm"};